import { LOCALES } from '@/constants/i18n';
import { timeFormatLocales } from '@/constants/date';
import { timeFormatDefaultLocale } from 'd3';
/**
 * maps translation response from API to message object for i18n plugin
 * @param {Array[Object]} translations
 */
export const mapToI18nObject = (translations) => {
  return Object.assign(
    {},
    ...translations.map((item) => {
      return { [item.key]: item.text };
    })
  );
};

/**
 * optimistic conversation from any locale format en-US or EN_US to only return the language
 *
 * @param language can be a locale string or 2 letter language
 * @returns {string|*} language part of the given string
 */
export const sanitizeLanguage = (language) => {
  if (language.length > 2) {
    return language.substr(0, 2);
  }
  return language;
};

/**
 * returns name possessive form
 * @param {String} name
 * @param {String} locale
 */
export const possessiveName = (name, locale) => {
  switch (locale) {
    case LOCALES.DE_DE.id:
      return name.match(/[sßxz]$/i) ? `${name}'` : `${name}s`;
    default:
      return name.match(/[sxz]$/i) ? `${name}'` : `${name}'s`;
  }
};

/**
 * returns initials of two names
 * @param {String} firstName
 * @param {String} lastName
 */
export const initials = (firstName, lastName) => {
  return `${firstName.trim().slice(0, 1)}${lastName.trim().slice(0, 1)}`;
};

/**
 * EN_UK is the former id of EN_GB, it can still be part of stored settings or links
 * @param {String} localeId e.g. 'EN_UK', 'de_at'
 * @returns {String|undefined} e.g. 'EN_GB', 'DE_AT'
 */
export const normalizeLocaleId = (localeId) => {
  if (!localeId) return undefined;
  const id = localeId.toUpperCase();
  return id === 'EN_UK' ? 'EN_GB' : id;
};

// d3 month and day names: of the regional format, or else of its language
export const updateD3Locale = (locale) => {
  const language = sanitizeLanguage(locale || '');
  const languageFallback = Object.keys(timeFormatLocales).find((id) => id.startsWith(`${language}_`));
  timeFormatDefaultLocale(timeFormatLocales[locale] || timeFormatLocales[languageFallback] || timeFormatLocales.EN_US);
};

export const titleCase = (string) => string[0].toUpperCase() + string.substr(1).toLowerCase();

export const toLocaleCurrencyFormat = (locale, number, factionDigits = 2) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: factionDigits,
    maximumFractionDigits: factionDigits,
  }).format(number);
};
